import { motion } from "framer-motion";
import { Gift, Check } from "lucide-react";
import { IMAGES, CLINIC } from "@/data";

const perks = [
  "Up to $1,095 of free dental over 2 years",
  "Check-ups, cleans, fillings & more",
  "Bulk-billed — no out-of-pocket cost",
];

export default function KidsOffer() {
  return (
    <section id="kids" data-testid="kids-section" className="py-24 md:py-32 bg-pd-forest relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-pd-sage/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-pd-terra/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 rounded-full bg-pd-terra/20 border border-pd-terra/30 px-4 py-1.5 mb-6">
            <Gift size={15} className="text-pd-accent" />
            <span className="text-pd-bg/90 text-xs font-medium tracking-wide uppercase">Child Dental Benefits Schedule</span>
          </div>
          <h2 className="font-display text-4xl lg:text-6xl font-light leading-[1.05] text-pd-bg">
            Free dental care <br /> for <span className="italic text-pd-accent">your kids.</span>
          </h2>
          <p className="mt-6 text-lg text-pd-bg/75 max-w-lg">
            Eligible children can receive free dental treatment through the Australian
            Government's CDBS scheme. We make it easy — we'll even check your eligibility for you.
          </p>
          <div className="mt-8 space-y-3">
            {perks.map((p) => (
              <div key={p} className="flex items-center gap-3 text-pd-bg/90">
                <span className="w-6 h-6 rounded-full bg-pd-sage/30 flex items-center justify-center shrink-0">
                  <Check size={14} className="text-pd-sage" />
                </span>
                {p}
              </div>
            ))}
          </div>
          <a
            href="#contact"
            data-testid="kids-book-btn"
            className="mt-9 inline-flex items-center gap-2 bg-pd-terra hover:bg-pd-terradark text-white rounded-full px-8 py-4 font-medium transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-pd-terra/30"
          >
            Check My Child's Eligibility
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="rounded-[2rem] overflow-hidden shadow-2xl">
            <img src={IMAGES.kids} alt="Happy child at the dentist" className="w-full h-[460px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -left-4 sm:left-6 bg-pd-bg rounded-2xl px-6 py-4 shadow-xl">
            <div className="font-display text-3xl text-pd-accent leading-none">$0</div>
            <p className="text-xs text-pd-body mt-1">out-of-pocket for eligible kids</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
